import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Raisins.css";

export default function Raisins() {
    const raisinProducts = [
        {
            id: 1,
            name: "GOLDEN RAISINS",
            image: "/assets/img/Raisins/Golden-Raisins.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bakery products",
                        "Breakfast cereals",
                        "Snack mixes",
                        "Confectionery items",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Attractive golden color",
                        "Naturally sweet taste",
                        "Rich in nutrients",
                        "Premium quality variety",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "BLACK RAISINS",
            image: "/assets/img/Raisins/Black-Raisins.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Traditional sweets",
                        "Health food products",
                        "Daily consumption",
                        "Snack packs",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich antioxidant content",
                        "Natural sweetness",
                        "High nutritional value",
                        "Popular consumer choice",
                    ],
                },
            ],
        },

        {
            id: 3,
            name: "GREEN RAISINS",
            image: "/assets/img/Raisins/Green-Raisins.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Premium dry fruit mixes",
                        "Bakery industry",
                        "Desserts",
                        "Retail packaging",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Distinct flavor",
                        "Soft texture",
                        "Premium appearance",
                        "High market demand",
                    ],
                },
            ],
        },

        {
            id: 4,
            name: "BROWN RAISINS",
            image: "/assets/img/Raisins/Brown-Raisins.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bakery products",
                        "Snack foods",
                        "Traditional recipes",
                        "Food processing industries",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Natural sweetness",
                        "Rich flavor profile",
                        "Good shelf life",
                        "Widely consumed variety",
                    ],
                },
            ],
        },

        {
            id: 5,
            name: "SULTANA RAISINS",
            image: "/assets/img/Raisins/Sultana-Raisins.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Cakes and pastries",
                        "Breakfast cereals",
                        "Food processing",
                        "Snack products",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Seedless variety",
                        "Naturally sweet taste",
                        "Soft texture",
                        "Widely used globally",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Raisins"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Raisins Product Range</h1>

                    <p className="pp-subtitle">
                        Explore our premium quality Raisins products sourced from trusted
                        suppliers worldwide.
                    </p>

                    <div className="pp-grid">
                        {raisinProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>

                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}